var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mr-section-container mr-widget-workflow"},[_c('div',{staticClass:"mr-widget-section"},[_c('div',{staticClass:"mr-widget-content"},[_vm._t("default")],2),_vm._v(" "),_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }